import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout-private/dashboard/")({
	component: () => <div>Hello /_layout-private/dashboard/!</div>,
});
